import LogoutRoute from './LogoutRoute';

export default LogoutRoute;
